const initialState = {
  tbtSignings: [],
  fetching: false,
  searchTerm: '',
  filters: {},
  pagination: {
    current: 1,
    pageSize: 15,
    total: 0,
  },
  tbtSigningModal: {
    show: false,
    id: null,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'TBT_SIGNING_FETCH_REQUEST':
      return {
        ...state,
        fetching: true,
      };

    case 'TBT_SIGNING_FETCH_SUCCESS':
      return {
        ...state,
        fetching: false,
        tbtSignings: action.payload.data || action.payload.rows || action.payload,
        pagination: action.payload.pagination || state.pagination,
      };

    case 'TBT_SIGNING_FETCH_FAILURE':
      return {
        ...state,
        fetching: false,
      };

    case 'TBT_SIGNING_SET_SEARCH_TERM':
      return {
        ...state,
        searchTerm: action.payload,
      };

    case 'TBT_SIGNING_SET_FILTERS':
      return {
        ...state,
        filters: action.payload,
      };

    case 'TBT_SIGNING_SHOW_MODAL':
      return {
        ...state,
        tbtSigningModal: {
          show: true,
          id: action.payload,
        },
      };

    case 'TBT_SIGNING_HIDE_MODAL':
      return {
        ...state,
        tbtSigningModal: {
          show: false,
          id: null,
        },
      };

    case 'TBT_SIGNING_DID_SIGN':
      return {
        ...state,
        tbtSigningModal: {
          show: false,
          id: null,
        },
        // Refresh the list after signing
        fetching: true,
      };

    default:
      return state;
  }
};
